import { Badge } from '@givebutter/primitives/badge';
import { upperFirst } from 'lodash';
import { EngageDelivery, EngageMessageChannel } from 'types/domain';

interface StatusBadgeProps {
    row: EngageDelivery;
    channel?: EngageMessageChannel;
}

const StatusBadge = ({ row, channel }: StatusBadgeProps) => {
    switch (row.status) {
        case 'queued':
        case 'sending':
        case 'sent':
            return <Badge>{upperFirst(row.status)}</Badge>;
        case 'failed':
            return (
                <Badge color="error">
                    {row.failed_reason === 'bounced' ? 'Bounced' : 'Failed'}
                </Badge>
            );
        case 'draft':
            return <Badge color="neutral">{upperFirst(row.status)}</Badge>;
        case 'delivered': {
            if (channel === 'sms') {
                return (
                    <Badge color="success">{row.first_clicked_at ? 'Clicked' : 'Delivered'}</Badge>
                );
            }

            if (row.first_clicked_at) {
                return <Badge color="success">Clicked</Badge>;
            }

            if (row.first_opened_at) {
                return <Badge color="success">Opened</Badge>;
            }

            return <Badge>Unopened</Badge>;
        }
        default:
            return null;
    }
};

export { StatusBadge };
